import { Fragment, useState, useEffect } from "react";
import React from "react";
import { withRouter } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Button, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import { Box, IconButton, Stack, TableContainer } from "@mui/material";
import TableRow from "@mui/material/TableRow";
import { obtenerAllDatosMagueyHistorico } from "../../redux/DucksUsuarioAgricola/DatosMagueyHistoricoDucks";
const PanelConsultaMovimiento = (props) => {
  const dispatch = useDispatch();
  let dataMagueyHistorico = []
  dataMagueyHistorico = useSelector((store) => store.DatosMagueyHistoricoApi.data.data);
  let dataPredio = useSelector((store) => store.DatosPredioApi.data.data);

  /*React.useEffect(() => {
    dispatch(obtenerAllDatosMagueyHistorico());
  }, []);*/

  useEffect(() => {
    dispatch(obtenerAllDatosMagueyHistorico(props.history.location.state?.iddatospredio))
  }, [])
  return (
    <Fragment>
      <br />
      <div className="container">
        <h2 className="text-center">Consulta de Movimientos </h2>
        <div className="bg-light p-5 rounded ms-5">
          <div className="col-12 pt-4">
            <h4 className="text-center">HISTÓRICOS: {props.history.location.state?.nombrepredio} </h4>
            <Paper sx={{ width: "100%" }}>
              <TableContainer sx={{ maxHeight: 700 }}>
                <Table>
                  <TableHead>
                    <TableRow>

                      <TableCell>Inspector</TableCell>
                      <TableCell>Fecha Creación </TableCell>
                      <TableCell>Fecha Descuento</TableCell>
                      <TableCell>No. Plantas restantantes</TableCell>
                      <TableCell>Maguey Descontado</TableCell>
                      <TableCell>Tapada</TableCell>
                      <TableCell>Kg.</TableCell>
                      <TableCell>Guia</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>

                    {dataMagueyHistorico !== null ? (
                      dataMagueyHistorico.map((item, i) => (
                        <TableRow
                          key={item.iddatosmagueyhistorico}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >

                          <TableCell>{item.usuariocambio ? item.usuariocambio : ""}</TableCell>
                          <TableCell>{item.fechacreacion ? new Date(item.fechacreacion).toISOString().split('T')[0] : "Sin registro"}</TableCell>
                          <TableCell>{item.fechacambio ? new Date(item.fechacambio).toISOString().split('T')[0] : "Sin registro"}</TableCell>
                          <TableCell>{item.numeroplantas}</TableCell>
                          <TableCell>{item.magueydescontado}</TableCell>
                          <TableCell>{item?.descuentomaguey?.tapada}</TableCell>
                          <TableCell>{item?.descuentomaguey?.kgvariedad}</TableCell>
                          <TableCell>{item.constancia.identificador}</TableCell>
                        </TableRow>

                      ))
                    ) : (
                      <></>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>


          </div>
        </div>

      </div>

    </Fragment>
  );
};

export default withRouter(PanelConsultaMovimiento);
